import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import { rem } from 'polished';
import objectPath from 'object-path';
import screen from 'superior-mq';
import Grid from '../grid';
import AboutContentDiv from '../about/about-content-div';
import AboutPlayButton from '../about/about-play-button';
import LazyImg from '../lazy-img';
import { YTModalContext } from '../with-youtube-modal';

const gridItemStyles = `
  ${screen.above(bp.mobile, `
    &:first-of-type {
      grid-column: 1 / span 4;
    }

    &:last-of-type {
      grid-column: 6 / -1;
    }
  `)};

  ${screen.below(bp.mobile, `
    grid-column: span 12;

    &:last-of-type {
      margin-top: 52px;
    }
  `)};
`;

const aboutStoryPlayButton = `
  position: absolute;
  z-index: 1;

  ${screen.above(bp.mobile, `
    top: -47px;
    left: 30px;
  `)};

  ${screen.below(bp.mobile, `
    top: 88px;
    right: -31px;
  `)};
`;

const Story = ({
  image,
  imageCaption,
  children,
  videoLink,
}) => (
  <Grid>
    <Grid.Item styles={gridItemStyles}>
      <ImageWrap>

        {objectPath.has(image, 'fields.file.url') &&
          <figure>
            <LazyImg
              width={466}
              height={710}
              src={`${image.fields.file.url}?w=466&h=710&q=88&fit=thumb&fm=jpg&fl=progressive`}
              alt={image.fields.description}
            />

            {!!imageCaption &&
              <Caption>{image.fields.description}</Caption>
            }
          </figure>
        }

        {videoLink &&
          <YTModalContext.Consumer>
            {context => (
              <AboutPlayButton
                styles={aboutStoryPlayButton}
                onClick={(e) => { context.toggleModal(e, videoLink); }}
                aria-label="Open video modal"
              />
            )}
          </YTModalContext.Consumer>
        }

      </ImageWrap>
    </Grid.Item>

    <Grid.Item styles={gridItemStyles}>
      <AboutContentDiv>

        {children}

      </AboutContentDiv>
    </Grid.Item>
  </Grid>
);

const Caption = styled.figcaption`
  margin-top: 10px;
  font-size: ${rem(16)};

  ${screen.below(bp.mobile, `
    font-size: ${rem(11)};
    text-align: center;
  `)};
`;

const ImageWrap = styled.div`
  position: relative;

  ${screen.below(bp.mobile, `
    max-width: 160px;
    margin: auto;
  `)};
`;

Story.propTypes = {
  image: PropTypes.object,
  imageCaption: PropTypes.string,
  children: PropTypes.node,
  videoLink: PropTypes.string,
};

export default Story;
